import { ROUTERS } from "@/shared/constants/router";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import {
  centeredRoute,
  layout1Route,
  layout2Route,
  // layoutRoute,
} from "../__root";

// const Dashboard = lazyRouteComponent(
//   () => import("@pages/Dashboard/dashboard")
// );
const MyClass = lazyRouteComponent(() => import("@pages/Class/my-class"));
const MyClassDetail = lazyRouteComponent(
  () => import("@pages/Class/my-class-detail")
);

const MockTest = lazyRouteComponent(() => import("@pages/MockTest/index"));
const MockTestResult = lazyRouteComponent(
  () => import("@pages/MockTestResult")
);

const CreactPracticeTest = lazyRouteComponent(
  () => import("@/pages/CreatePracticeTest/create-practice-test")
);

export const dashboardRoute = createRoute({
  getParentRoute: () => layout1Route,
  path: ROUTERS.HOME,
  component: MyClass,
});

export const myClassRoute = createRoute({
  getParentRoute: () => layout1Route,
  path: ROUTERS.MY_CLASS,
  component: MyClass,
});

function parseTestIdSearch(search: Record<string, unknown>) {
  const raw = search.test_id;
  if (raw === undefined || raw === null || raw === "") {
    return {};
  }
  const n = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(n)) {
    return {};
  }
  return { test_id: n };
}

export const myClassDetailRoute = createRoute({
  getParentRoute: () => layout2Route,
  path: ROUTERS.MY_CLASS_DETAIL,
  component: MyClassDetail,
  validateSearch: parseTestIdSearch,
});

export const mockTestRoute = createRoute({
  getParentRoute: () => centeredRoute,
  path: ROUTERS.MOCK_TEST,
  component: MockTest,
});

export const mockTestResultRoute = createRoute({
  getParentRoute: () => centeredRoute,
  path: ROUTERS.MOCK_TEST_RESULT,
  component: MockTestResult,
});

export const creactPracticeTestRoute = createRoute({
  getParentRoute: () => centeredRoute,
  path: ROUTERS.CREACT_PRACTICE_TEST,
  component: CreactPracticeTest,
});
